import { type Component, createApp } from "vue";
import { getActivePinia } from "pinia"
import installAvv from "./_abstract/install-avv";
import { useDirectives } from "@component-library/directives";

/** This is a preferred way for creating vue application, it will automatically inject all needed libraries. */
export const createVueApp = (rootComponent: Component, rootProps?: Record<string, unknown> | null) => {
  const app = createApp(rootComponent, rootProps)

  // Add support for pinia stores
  app.use(getActivePinia()!)

  // Used in _abstract components with A prefix - can be removed when these are no longers used.
  app.use({install: installAvv})

  // Directives
  useDirectives(app)

  return app
}
